import styles from "./DocumentsManager.module.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface DocumentSectionProps {
    title: string;
    count: number;
    isOpen: boolean;
    onToggle: () => void;
}

const DocumentSection = ({ title, isOpen, onToggle }: DocumentSectionProps) => {
    return (
        <tr className={styles.sectionRow} onClick={onToggle}>
            <td colSpan={6}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%',
                    justifyContent: 'center'
                }}>
                    <KeyboardArrowDownIcon
                        className={`${styles.iconExpand} ${isOpen ? styles.open : ''}`}
                    />
                    <span>{title}</span>
                </div>
            </td>
        </tr>
    );
};

export default DocumentSection;